import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import fetch from "../../../utils/fetch";

import Input from "../../../components/main/input";
import Button from "../../../components/main/button";
import Title from "../../../components/main/title";

import { useAuthStore } from "../../../store/auth";

interface Props {
    footer: any;
}

const bg: any = [];
const bg_rand = bg[Math.floor(Math.random() * 5)];

const ForgotPassword: React.FC<Props> = ({ footer }) => {
    const loggedIn = useAuthStore<any>((s) => s.loggedIn);
    const [email, setEmail] = useState("");
    const [buttonActive, setButtonActive] = useState({ forgot: false });

    if (loggedIn === true) {
        window.location.href = "/dashboard";
        return <></>;
    }

    const forgot = () => {
        setButtonActive({ ...buttonActive, forgot: true });
        const post = new fetch(
            "/auth/forgot-password",
            {
                email: email,
            },
            { success: true, error: true }
        ).post();

        post.then(() => {
            setButtonActive({ ...buttonActive, forgot: false });
        }).catch((e) => {
            setButtonActive({ ...buttonActive, forgot: false });
        });
    };

    return (
        <>
            <div id="login">
                <div>
                    <div className="auth-header-logo">
                        <span
                            className="logo-title"
                            onClick={() => {
                                window.location.href = "/";
                            }}
                        >
                            YPC VCA
                        </span>
                    </div>
                    <Title title="h2" value="Forgot password" />
                    <Input
                        name="email"
                        type="email"
                        placeholder="Email"
                        updateChange={(value) => {
                            setEmail(value);
                        }}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                forgot();
                            }
                        }}
                        counter
                        maxCounter={255}
                    />
                    <div className="text-right">
                        <Button
                            value="Reset Password"
                            disabled={buttonActive.forgot}
                            onClick={() => {
                                forgot();
                            }}
                        />
                    </div>
                    {footer}
                </div>
                <div className="position-relative" style={{ backgroundColor: "#155bd5" }}>
                    <div className="auth-bg-msg"></div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
